import { RedCrossIcon } from "../../../svg/red-cross-icon";

const ErrorState = ({ error }: { error: string }) => {
  return (
    <div className="flex h-full w-full items-center justify-center gap-2">
      <RedCrossIcon />
      <div className="text-sm">{error}</div>
    </div>
  );
};

export default ErrorState;
